import * as React from 'react';
import { Link } from 'react-router';
import { __, __r } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { InfoText, InfoType } from '../General/InfoText';
import { ItemsProductTable } from './Items/ItemsProductTable';
import { prop } from '../../../utilities';
import { FreeDeliveryBox } from './Summary/FreeDeliveryBox';
import { GiftcardCheckbox } from './GiftcardCheckbox';

interface Props {
  handleStepChange: (step: number) => void;
  theme: any;
  data: any;
  addToRequest: any;
  addToCart: any;
  isFetching: boolean;
  removeFromCart: any;
  changeCartItemNote: (gId: number, note: string) => void;
  changeCartNote: (note: string) => void;
  refreshCart: () => void;
  freeDel: number | null;
  isPriceWithVat: boolean;
  handlePaintChange: (goodId: number, wantPaint: boolean) => void;
  productHasPaint: boolean;
  updateCart: any;
}

function CartItemsPart({
  data,
  addToCart,
  isFetching,
  removeFromCart,
  refreshCart,
  freeDel,
  isPriceWithVat,
  handlePaintChange,
  updateCart,
}: Props) {
  const { items, problems, total_items_price, currency } = data;
  const normalItems = items.filter(i => !i.is_demand);

  const cartProblem = prop(
    problems.filter(p => p.type === 'availability')[0],
    'readable',
  );

  let percentage = 0;
  if (freeDel) {
    percentage =
      (+total_items_price * 100) / (freeDel + Number(total_items_price));

    if (percentage > 100) {
      percentage = 100;
    }
  }

  const showGiftcardOption = prop(data, 'giftcard_product', false);
  const printGiftcard = prop(data, 'print_giftcard', false);

  const onChangeGiftcardDelivery = e => {
    updateCart({ ...data, print_giftcard: e.target.value });
  };

  return (
    <>
      {cartProblem && (
        <InfoText
          maxWidth={1168}
          type={InfoType.ERROR}
          info={cartProblem}
          marginBottom={56}
        />
      )}
      <Wrapper>
        {normalItems.length > 0 && (
          <FlexColWrapper>
            <TitleWrapper>
              <Title>{__('Nákupný košík')}</Title>
            </TitleWrapper>
            <ItemsProductTable
              products={normalItems}
              isFetching={isFetching}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              refreshCart={refreshCart}
              isPriceWithVat={isPriceWithVat}
              handlePaintChange={handlePaintChange}
            />
            {showGiftcardOption && (
              <GiftcardCheckboxWrapper>
                <GiftcardCheckbox
                  name="printGiftcard"
                  onClick={onChangeGiftcardDelivery}
                  selected={printGiftcard}
                />
              </GiftcardCheckboxWrapper>
            )}
            <FreeDeliveryBoxWrapper>
              <FreeDeliveryBox
                currency={currency}
                value={freeDel}
                percentage={percentage}
              />
            </FreeDeliveryBoxWrapper>
          </FlexColWrapper>
        )}
      </Wrapper>
    </>
  );
}

const Wrapper = styled(FlexRow)`
  width: 100%;
  margin-bottom: ${rem(32)};
  margin-right: ${rem(32)};
  justify-content: space-between;
  p {
    text-align: center;
  }
`;

const TitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  padding-bottom: ${rem(32)};

  ${({ theme }) => theme.mediab.l925`
      margin-top: ${rem(56)};
  `}
`;

const Title = styled.h3`
  font-size: ${rem(24)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.secondary};
  margin: 0;
  line-height: ${rem(31)};
  font-weight: 500;
  text-transform: uppercase;
`;

const FreeDeliveryBoxWrapper = styled.div`
  margin-left: ${rem(20)};
`;

const GiftcardCheckboxWrapper = styled.div`
  margin-left: ${rem(28)};
`;

const FlexColWrapper = styled(FlexCol)`
  width: 100%;
`;
const WithTheme: any = withTheme(CartItemsPart);
export { WithTheme as CartItemsPart };
